import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DealSearchResult } from '../models/deal-search-result.model';
import { PaginatedResult } from '../models/paginated-result.model';
import { GetDealsQuery } from '../models/queries/get-deals-query.model';
import { API_BASE_URL } from '../injection-tokens';
import { ProductLineCode } from '../models/product-line-code.enum';

@Injectable({
  providedIn: 'root',
})
export class DealsService {
  private http = inject(HttpClient);

  private apiBaseUrl = inject(API_BASE_URL);

  search(query: GetDealsQuery): Observable<PaginatedResult<DealSearchResult>> {
    return this.http.post<PaginatedResult<DealSearchResult>>(`${this.apiBaseUrl}/v1/deals`, query);
  }

  export(productLineCode?: ProductLineCode): Observable<Blob> {
    return this.http.post(`${this.apiBaseUrl}/v1/deals/export`, null, {
      params: {
        productLine: productLineCode ?? '',
      },
      responseType: 'blob',
      headers: {
        Accept: 'text/csv',
      },
    });
  }
}
